<h3 class="soft-text-l ml-2 mr-2">Zustazartikel wählen</h3>
<p class="soft-text color-light ml-2 mr-2">Es wurde festgestellt, dass das Produkt schwerer ist als geplant. Bitte wählen Sie das verwendete Extra-Material aus, indem Sie auf das verwendete Material tippen!</p>

<div class="c center pt-2 pb-2 min-h" *ngIf="loading(); else itemsTemplate">
    <soft-loading-spinner class="spin"></soft-loading-spinner>
</div>

<ng-template #itemsTemplate>
    <div class="c column ml-2 mr-2 border-box mt-2">
        <div class="c row space-between center-v mb-3 mt-3" *ngIf="legierungen() as legierungen">
            <label for="select" class="mb-1" style="font-weight: 700">Legierung</label>
            <soft-select placeholder="Auswählen" id="select" [value]="selectedLegierung" (valueChange)="selectedLegierung.set($event)">
                <soft-select-option *ngFor="let legierung of legierungen" [value]="legierung">
                    {{ legierung?.charge }}
                </soft-select-option>
            </soft-select>
        </div>

        <ng-container *ngIf="(((legierungen()?.length ?? 0) > 0) && (selectedLegierung())); else selectLegierungFirstTemplate">
            <strong class="mb-1 mt-3">Artikel</strong>
            <div *ngFor="let item of extraMaterials(); let last = last" [class.border-b]="!last" (click)="close(item)" class="c pt-2 pb-2 column center-v">
                <span class="soft-overline" *ngIf="item?.cartikelnummer">{{ item?.cartikelnummer }}</span>
                <strong>{{ item?.artbez1 || '-' }}</strong>
                <span class="soft-text-s color-light" *ngIf="item?.artbez2">{{ item?.artbez2 }}</span>
                <span class="soft-text-s color-light" *ngIf="item?.artbez3">{{ item?.artbez3 }}</span>
            </div>
        </ng-container>

        <ng-template #selectLegierungFirstTemplate>
            <div class="p-4">
                Bitte wählen Sie Zuerst eine Legierung aus
            </div>
        </ng-template>
    </div>
</ng-template>

<button class="soft-button secondary custom mt-3" (click)="close(null)">Abbrechen</button>
